import { render, staticRenderFns } from "./PanelCompany.vue?vue&type=template&id=740290bf&"
import script from "./PanelCompany.vue?vue&type=script&lang=js&"
export * from "./PanelCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports